import React, { useState } from 'react'
import { Link ,useNavigate} from 'react-router-dom'
import axios from 'axios'




function Login() {


    
  
  const [email,setEmail]=useState('')
  const [password,setPassword]=useState('')
  



  const navigate=useNavigate()

      const handleAPI=(e)=>{
          e.preventDefault()
           axios.post('https://tinkus.onrender.com/login',{
           
            email: email,
            password: password,
           
           })
           .then((result)=>{
            
            localStorage.setItem("token",result.data.token)
            localStorage.setItem("useuserId",result.data.userId)
            alert("Login SuccessFully")
            navigate('/')
           })
          .catch((err)=>{
            console.log(err)
    
            alert(err.response.data.msg)
          })


      }

    return (
        <div>
        <h1><Link to='/signup'> <button className='btn btn bg-warning'>signup</button></Link></h1>

           <div className="container">

           <form action="/action_page.php">
                <div class="mb-3 mt-3">
                    <label for="email" class="form-label">Email:</label>
                    <input onChange={(e)=>setEmail(e.target.value)} type="email" class="form-control" id="email" placeholder="Enter email" name="email" />
                </div>
                <div class="mb-3">
                    <label for="pwd" class="form-label">Password:</label>
                    <input onChange={(e)=>setPassword(e.target.value)} type="password" class="form-control" id="pwd" placeholder="Enter password" name="pswd" />
                </div>
               
                <button onClick={handleAPI} type="submit" class="btn btn-primary">Submit</button>
            </form>


           </div>


        </div>
    )
}

export default Login
